import React from "react";

/**
 * "Bilet oynanırken tüm oranların değişebileceğini kabul et" onayı (4nala ile aynı metin).
 * Sabit oranlı ve uzun vadeli kuponlarda oran gönderim anında değişebildiği için OYNA bu
 * onaya bağlı: işaret kaldırılırsa kupon oynatılmıyor. Varsayılanı `true` (servislerin
 * `defaultOptions` değeri).
 *
 * `tone`: kupon kenar çubuğu koyu zeminde ("dark"), /bilet-onay sayfası beyaz zeminde ("light").
 */
export function AcceptOddsChange({checked, onChange, tone = "dark"}: {
    checked: boolean;
    onChange: () => void;
    tone?: "dark" | "light";
}) {
    return (
        <div className={`accept-odds-change ${tone}`} onClick={onChange}>
            <button type="button"
                    className={`button xs primary filled betting-mobile-point-checkbox p-0 ${checked ? 'point-selected' : ''}`}>
                {checked &&
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path d="M6.66658 2L2.99992 5.66667L1.33325 4" stroke="white" strokeWidth="1.6"
                              strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>}
            </button>
            <span className={"text-xxsmall accept-odds-change-label"}>
                Bilet oynanırken tüm oranların değişebileceğini kabul et
            </span>
        </div>
    );
}
